import { LIMIT_BYTE, METADATA_FIELDS_TYPE, PROMPT_PRESET_RESPONSE_FORMATS } from "@constants";
import * as yup from "yup";
import i18n from "i18next";

export function getPropertyPanelPromptPresetsMetadata({ data, onHandleSubmitUpdatePreset, isEditButtonDisabled }) {
    return [
        {
            title: undefined,
            attributions: [
                {
                    id: "description",
                    type: METADATA_FIELDS_TYPE.TEXT_AREA,
                    subtitle: "Description",
                    value: data.description,
                    isEditable: !isEditButtonDisabled,
                    onSubmitEditValue: (value) => onHandleSubmitUpdatePreset("description", value),
                    validationRule: yup.object().shape({
                        fieldValue: yup
                            .string()
                            .maxBytes(
                                LIMIT_BYTE.description,
                                i18n.t(
                                    `This field can be up to {{maxByte}} bytes.`,
                                    `This field can be up to {{maxByte}} bytes.`,
                                    { maxByte: LIMIT_BYTE.description },
                                ),
                            ),
                    }),
                },
                {
                    id: "prompt",
                    type: METADATA_FIELDS_TYPE.TEXT_AREA,
                    subtitle: "Prompt",
                    value: data.prompt,
                    isEditable: !isEditButtonDisabled,
                    isRequired: true,
                    validationRule: yup.object().shape({
                        fieldValue: yup
                            .string()
                            .required(i18n.t("Prompt is required.", "Prompt is required."))
                            .maxBytes(
                                LIMIT_BYTE.description,
                                i18n.t(
                                    `This field can be up to {{maxByte}} bytes.`,
                                    `This field can be up to {{maxByte}} bytes.`,
                                    { maxByte: LIMIT_BYTE.description },
                                ),
                            ),
                    }),
                    onSubmitEditValue: (value) => onHandleSubmitUpdatePreset("prompt", value),
                },
                {
                    id: "responseFormatCode",
                    type: METADATA_FIELDS_TYPE.SINGLE_SELECT,
                    subtitle: "Response format",
                    value: data.responseFormatCode,
                    isEditable: !isEditButtonDisabled,
                    isRequired: true,
                    options: PROMPT_PRESET_RESPONSE_FORMATS.map(({ label, value }) => ({
                        value,
                        label: i18n.t(`common::label::${label}`, label),
                    })),
                    onSubmitEditValue: (value) => onHandleSubmitUpdatePreset("responseFormatCode", value),
                },
            ],
        },
    ];
}
